// extracted by mini-css-extract-plugin
export default {"class":"Card_class__jVAqe","userss":"Card_userss__3EXiK"};